import { match } from 'ts-pattern';

import { Routes } from '~/domains/common/constants/routes';
import {
  buyerOfferPanelQuery,
  sellerOfferPanelQuery,
} from '~/domains/marketplace/domains/offers/utils/offerPanelQuery';
import type { OfferFeedItem } from '~/services/marketplace/marketplace-service.schemas';

import type { OfferFeedKind } from './resolveOfferFeedKind';

const counterPanelHref = (item: OfferFeedItem): string | null =>
  item.listingId || item.entryId
    ? Routes.marketplaceOffers({
        offer: item.offerId,
        ...buyerOfferPanelQuery({
          offerId: item.offerId,
          listingId: item.listingId,
          entryId: item.entryId,
          targetUserId: item.actor.userId,
        }),
      })
    : null;

const receivedOfferPanelHref = (item: OfferFeedItem): string | null =>
  item.entryId
    ? Routes.marketplaceOffers({
        offers: 'sell',
        offer: item.offerId,
        ...sellerOfferPanelQuery({ offerId: item.offerId, entryId: item.entryId }),
      })
    : null;

export const offerFeedHref = (item: OfferFeedItem, kind: OfferFeedKind): string =>
  match(kind)
    .with('counter', () => counterPanelHref(item))
    .with('offer', () => receivedOfferPanelHref(item))
    .with('accepted', () => null)
    .exhaustive() ?? Routes.marketplaceOffer(item.offerId);
